var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:[
  'asm-value',
   ( _obj = {}, _obj[("asm-value--size-" + _vm.size)] = _vm.size, _obj )]},[_vm._v(" "+_vm._s(_vm.priceDisplay(_vm.num, _vm.hideChange))),_c('span',{staticClass:"asm-value__measure"},[_vm._v(_vm._s(_vm.measure))])])}
var staticRenderFns = []

export { render, staticRenderFns }